const axios = require('axios').create(); 
import store from '../store'; 

const STATUS_DEFAULTS = {
    'in-stock': {
        key: 'in-stock',
        label: 'In Stock',
        detail: 'May take up to 3 days to ship.'
    },
    'made-to-order': {
        key: 'made-to-order',
        label: 'Made to Order',
        detail: 'May take up to 5 weeks to ship.'
    },
    'out-of-stock': {
        key: 'out-of-stock',
        label: 'Out of Stock',
        detail: 'Currently unavailable. Check back soon.'
    },
    'discontinued': {
        key: 'discontinued',
        label: 'Discontinued',
        detail: 'This item is no longer available.'
    },
    'back-ordered': {
        key: 'back-ordered',
        label: 'Back-Ordered',
        detail: 'Temporarily unavailable. Back in 2–3 weeks'
    },
    'coming-soon': {
        key: 'coming-soon',
        label: 'Coming Soon',
        detail: 'Available soon. Check back for release date.'
    }
};

const normalizeTag = tag => String(tag || '')
    .trim()
    .toLowerCase()
    .replace(/[\s_]+/g, '-')
    .replace(/-+/g, '-');

const normalizeTags = tags => {
    const values = Array.isArray(tags) ? tags : String(tags || '').split(',');
    return new Set(values.map(normalizeTag).filter(Boolean));
};

const configuredStatus = key => {
    const fallback = STATUS_DEFAULTS[key];
    const configuredMessage = window.sf_options?.stockStatusMessages?.[key];

    if (!configuredMessage || typeof configuredMessage !== 'string') {
        return { ...fallback };
    }

    const message = configuredMessage.replace(/\s+/g, ' ').trim();
    const separator = message.indexOf(':');

    if (separator < 1) {
        return {
            ...fallback,
            detail: message
        };
    }

    return {
        ...fallback,
        label: message.slice(0, separator).trim(),
        detail: message.slice(separator + 1).trim()
    };
};

/**
 * The Shopify adapter responds to the factory used by the platform. 
 */
const Shopify = {

    goToPartResults(handle, options) {

        let url = `/collections/${handle}/?results=1`; 

        if ( options ) {
            url += '&' + (new URLSearchParams(options)).toString()
        }

        window.location.href = url; 
    }, 

    buildProductUrl(vehicle, build_id) {
        let handle = store.products[build_id].handle;
        let collection = store.collection;

        return new Promise( resolve => {
            if ( vehicle != null ) {
                resolve(`/collections/${collection}/products/${handle}`); 
            } else {
                resolve(`/products/${handle}`); 
            }
        }); 
    }, 

    addToCart: async (build_id, quantity, slug) => {
        let variant_id = store.products[build_id].id;

        let {data} = await axios.post('/cart/add.js', {
            id: variant_id, 
            quantity: quantity,
            properties: { _seatshop: 1, _collection: slug}
        }); 

        return data; 
    }, 

    buildProduct(data) {
        let variant = data.variants[0]; 
        const tags = data.tags || '';
        const tagList = normalizeTags(tags);
        const available = variant.inventory_management != 'shopify'
            || variant.inventory_policy != 'deny'
            || variant.inventory_quantity > 0;

        return {
            handle: data.handle, 
            title: data.title,
            id: variant.id, 
            available,
            eligible: !tagList.has('not-eligible'),
            image: data.image?.src != null ? data.image.src.replace(/\.(jpe?g|png|gif)\?/i, '_600x.$1?') : null,
            tags,
            status: Shopify.getProductStatus(tagList, available)
        }
    },

    getProductStatus(tags, available = false) {
        const tagList = tags instanceof Set ? tags : normalizeTags(tags);

        if (tagList.has('discontinued')) {
            return configuredStatus('discontinued');
        }

        if (tagList.has('coming-soon')) {
            return configuredStatus('coming-soon');
        }

        if (tagList.has('out-of-stock') || tagList.has('out-stock')) {
            return configuredStatus('out-of-stock');
        }

        if (tagList.has('back-ordered')) {
            return configuredStatus('back-ordered');
        }

        if (tagList.has('made-to-order')) {
            return configuredStatus('made-to-order');
        }

        if (tagList.has('in-stock')) {
            return configuredStatus('in-stock');
        }

        // Inventory is the final fallback so every PLP product has a status,
        // even when a legacy product is missing its explicit status tag.
        return configuredStatus(available ? 'in-stock' : 'out-of-stock');
    }

}

export default Shopify;
